'use client';
import styled from 'styled-components';

import Markdown from '@components/utils/Markdown';

const DiscountContent = styled(Markdown)`
  padding: 20px;
  text-align: justify;

  a {
    color: ${(props) => props.theme.palette.primaryBrand};
  }
`;

export default DiscountContent;
